<template>
  <el-dialog
    width="520px"
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="visible"
    @closed="resetForm"
  >
    <template #title>
      <div class="operate-title">
        <i class="el-icon-key" />
        <span>操作码校验</span>
      </div>
    </template>

    <template #default>
      <div class="operate-tip">
        您正在对开关
        <strong class="operate-tip__alias">{{ switchAlias }}</strong>
        执行
        <strong class="operate-tip__action" :class="`is-${operateType}`">
          {{ operateLabel }}
        </strong>
        操作，操作码将发送至您输入的邮箱，输入操作码后由后台校验。
      </div>

      <el-form
        ref="operateFormRef"
        :model="form"
        :rules="rules"
        label-width="90px"
      >
        <el-form-item label="邮箱" prop="email">
          <el-input
            v-model.trim="form.email"
            placeholder="请输入接收操作码的邮箱地址"
            clearable
          />
        </el-form-item>

        <el-form-item label="操作码" prop="code">
          <el-input
            v-model.trim="form.code"
            placeholder="请输入6位数字操作码"
            maxlength="6"
            @keyup.enter.native="validateCode"
          >
            <template #append>
              <el-button
                class="operate-send-btn"
                :loading="sending"
                :disabled="countdown > 0"
                @click="sendCode"
              >
                {{ countdown > 0 ? `${countdown}s后重发` : '发送操作码' }}
              </el-button>
            </template>
          </el-input>
        </el-form-item>
      </el-form>
    </template>

    <template #footer>
      <el-button size="small" @click="$emit('cancel')">取 消</el-button>
      <el-button
        type="primary"
        size="small"
        :loading="validateIng"
        @click="validateCode"
      >
        校验并执行{{ operateLabel }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import { SendOperateCodeToEmail, ValidateOperateCode } from '@/api/SwitchDevice'
/** 默认操作码发送间隔时间【秒】，纯样式演示缩短为 60s */
const DEFAULT_COUNT_DOWN = 60
export default {
  name: 'OperateDialog',
  props: {
    /** 是否显示弹框 */
    visible: {
      type: Boolean,
      default: false
    },
    /** 开关别名 */
    switchAlias: {
      type: String,
      default: ''
    },
    /**
     * 操作类型
     * 1：分闸, 2：合闸
     */
    operateType: {
      type: String,
      default: '1'
    },
    /** 电站ID */
    orgId: {
      type: String,
      default: ''
    },
    /** 开关ID */
    switchDeviceId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      /** 发送操作码中 */
      sending: false,
      /** 校验操作码中 */
      validateIng: false,
      /** 发送倒计时 */
      countdown: 0,
      /** 倒计时定时器 */
      countdownTimer: null,
      /** 校验表单 */
      form: {
        /** 接收操作码的邮箱 */
        email: '',
        /** 操作码 */
        code: ''
      },
      /** 校验规则 */
      rules: {
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入操作码', trigger: 'blur' },
          {
            pattern: /^\d{6}$/,
            message: '操作码为6位数字',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    /** 操作类型文案 */
    operateLabel () {
      const labelMap = {
        '1': '分闸',
        '2': '合闸'
      }
      return labelMap[this.operateType] || ''
    }
  },
  methods: {
    /** 发送操作码 */
    sendCode () {
      this.$refs.operateFormRef.validateField('email', valid => {
        if (!valid) {
          this.sending = true
          SendOperateCodeToEmail({
            orgId: this.orgId,
            switchDeviceId: this.switchDeviceId,
            operateType: this.operateType,
            receiveEmailAddress: this.form.email
          }).then(() => {
            this.$message({
              message: '操作码已发送至邮箱',
              type: 'success'
            })
            this.sending = false
            this.startCountdown()
          }).catch(() => {
            this.sending = false
            this.$message({
              message: '操作码发送失败',
              type: 'error'
            })
          })
        }
      })
    },

    /** 校验操作码 */
    validateCode () {
      this.$refs.operateFormRef.validate(valid => {
        if (valid) {
          this.validateIng = true
          ValidateOperateCode({
            deviceId: this.switchDeviceId,
            operatepassword: this.form.code,
          }).then(() => {
            this.validateIng = false
            this.$message({
              message: '操作码校验通过',
              type: 'success'
            })
            this.$emit('confirm')
          }).catch(() => {
            this.validateIng = false
            this.$message({
              message: '操作码校验失败',
              type: 'error'
            })
          })
        }
      })
    },

    /** 开始发送倒计时 */
    startCountdown () {
      this.clearCountdown()
      this.countdown = DEFAULT_COUNT_DOWN
      this.countdownTimer = window.setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          this.clearCountdown()
        }
      }, 1000)
    },

    /** 清除倒计时 */
    clearCountdown () {
      if (this.countdownTimer) {
        window.clearInterval(this.countdownTimer)
        this.countdownTimer = null
      }
      this.countdown = 0
    },

    /** 弹框关闭后重置表单 */
    resetForm () {
      this.form.email = ''
      this.form.code = ''
      this.clearCountdown()
      this.$refs.operateFormRef && this.$refs.operateFormRef.clearValidate()
    }
  }
}
</script>

<style scoped>
.operate-title {
  display: flex;
  align-items: center;
  color: #4fce6e;
  font-size: 16px;
  font-weight: 700;
}
.operate-title i {
  margin-right: 6px;
  font-size: 18px;
}
.operate-tip {
  margin-bottom: 16px;
  padding: 12px 14px;
  border-radius: 6px;
  background-color: #f5f7ff;
  color: #6b7280;
  font-size: 13px;
  line-height: 1.8;
}
.operate-tip__alias {
  color: #303133;
}
.operate-tip__action {
  margin: 0 2px;
  font-size: 14px;
}
.operate-tip__action.is-close {
  color: #13ce66;
}
.operate-tip__action.is-open {
  color: #f56c6c;
}
.operate-send-btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
</style>
